import { render, staticRenderFns } from "./RegisterPedigreeOrder.vue?vue&type=template&id=01325ac2"
import script from "./RegisterPedigreeOrder.vue?vue&type=script&lang=ts"
export * from "./RegisterPedigreeOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports